<template>
  <div class="pop-content">
    <span class="pop-title"><strong>Order by</strong></span>
    <ion-list>
      <ion-radio-group>
        <ion-item lines="none">
          <ion-label>Cod</ion-label>
          <ion-radio
            slot="end"
            @ionSelect="orderPop = 'cod'"
            :checked="orderPop == 'cod'"
          >
          </ion-radio>
        </ion-item>
        <ion-item lines="ref">
          <ion-label>Ref</ion-label>
          <ion-radio
            slot="end"
            @ionSelect="orderPop = 'ref'"
            :checked="orderPop == 'ref'"
          >
          </ion-radio>
        </ion-item>
      </ion-radio-group>
    </ion-list>
    <span class="pop-title"><strong>Order</strong></span>
    <ion-list>
      <ion-radio-group>
        <ion-item lines="none">
          <ion-label>ASC</ion-label>
          <ion-radio
            slot="end"
            @ionSelect="orderTypePop = 'asc'"
            :checked="orderTypePop == 'asc'"
          >
          </ion-radio>
        </ion-item>
        <ion-item lines="none">
          <ion-label>DESC</ion-label>
          <ion-radio
            slot="end"
            @ionSelect="orderTypePop = 'desc'"
            :checked="orderTypePop == 'desc'"
          >
          </ion-radio>
        </ion-item>
      </ion-radio-group>
    </ion-list>
    <div class="pop-btn">
      <ion-button color="primary" expand="block" @click="apply">Apply</ion-button>
    </div>
  </div>
</template>

<script>
// import axios from "axios"
// import Vue from "vue"
export default {
  name: "PopoverOrders",
  props: {
    orderType: { type: String, default: '' },
    order: { type: String, default: '' },
  },
  data: function() {
    return {
      orderPop: {},
      orderTypePop: {},
    }
  },
  methods: {
    apply: function(success) {
      let response = {
        success,
        order: this.orderPop,
        orderType: this.orderTypePop,
      };
      this.$ionic.popoverController.dismiss(response);
    }
  },
  created: function() {
    this.orderPop = JSON.parse(JSON.stringify(this.order))
    this.orderTypePop = JSON.parse(JSON.stringify(this.orderType))
  },
  mounted: function() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pop-content {
  margin-top: 20px;
  text-align: left;
}

.pop-title {
  padding: 0 15px;
}

.pop-btn {
  padding: 0 12px 10px;
}

.pop-light-wrapper {
  padding: 10px 12px 20px;
}

.pop-light-wrapper > div {
  cursor: pointer;
}
</style>